var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.items),function(item,i){return [_c('schedule-shift-day-detail',{key:`shift_${item.shift.id}_${i}`,attrs:{"shift":item.shift,"assignments":item.assignments,"group_id":_vm.group_id,"providerMap":_vm.providerMap,"date":_vm.date,"readOnly":_vm.readOnly},on:{"shiftDayEdit":_vm.onShiftDayEdit}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }